import * as Yup from 'yup'

export const schemaProfile = (t: (key: string) => string) => ({
  email: Yup.string().required(t('requiredMessage')),
  companyName: Yup.string().required(t('requiredMessage')),
  phone: Yup.string().required(t('requiredMessage')),
})
